import React from "react";
import styles from "./SellerComments.module.scss";
import InfoCard from 'gui/pages/mainRouter/pages/ad/components/commons/infoCard';
import ErrorRoundedIcon from '@material-ui/icons/ErrorRounded';
import Comments from './components/comments';
import Detail, {IDetailProps} from './components/detail';
import {isUndefined} from "lodash";

export interface ISellerCommentsProps {
  title?: string;
  description?: string;
  className?: string;
  icon?: any;
  iconContainerClassName?: string;
  details?: IDetailProps[];

  mustLoadDescription?: boolean;
}

const SellerComments = ({
                          title,
                          description,
                          className,
                          details,
                          icon,
                          iconContainerClassName,
                          mustLoadDescription
                        }: ISellerCommentsProps) => {
  return (
    <InfoCard
      title={title || ''}
      icon={icon}
      toolTip={title || ''}
      iconContainerClassName={iconContainerClassName}
      loading={mustLoadDescription ? isUndefined(description) : (isUndefined(title) && isUndefined(description))}
      className={className}
    >
      <div className={styles.SellerComments}>
        <Comments description={description || ''}/>
        {(details || [])
          .map((detail, index) => <Detail key={index} {...detail}/>)
        }
      </div>
    </InfoCard>
  );
}

SellerComments.defaultProps = {
  title: "",
  description: "",
  icon: ErrorRoundedIcon,
  details: [],
};

export default SellerComments;
